import { useQuery } from '@tanstack/react-query';
import { COUNTRIES_KEY } from 'src/utils/constants/queryKeys';
import { getCounties } from '../services/fn-api/Common';

export const useGetCounties = (state: string) => {
  return useQuery({
    queryKey: [COUNTRIES_KEY, state],
    queryFn: () => getCounties(state),
    enabled: !!state,
  });
};
